import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppButton } from "../../Generic/AppButton";
import { AppDragableBottomSheet } from "../../Generic/AppDragableBottomSheet";

type Props = {
  isOpen?: boolean;
  defaultOpen?: boolean;
  onClose?: () => void;
  onClick: () => void;
};

export default function CareMomentsIntroBottomSheet(props: Props) {
  const [isSelfOpen, setSelfOpen] = React.useState(props.defaultOpen ?? false);
  const isOpen = props.isOpen ?? isSelfOpen;
  const onClose = props.onClose ?? (() => setSelfOpen(false));

  return (
    <>
      <AppDragableBottomSheet
        withAnimatePresence={true}
        isOpen={isOpen}
        closeOnDrag={true}
        onRequestClose={onClose}
      >
        <Content>
          <Image />
          <Heading>{translate(STRINGS.EXCITING_NEWS_AHEAD)}</Heading>
          <Description>{translate(STRINGS.EXPLORE_A_CAREER_ENHANCEMENTS)}</Description>
          <AppButton
            size="large"
            onClick={() => {
              props.onClick();
              onClose();
            }}
          >
            {translate(STRINGS.DISCOVER_YOUR_JOURNEY)}
          </AppButton>
        </Content>
      </AppDragableBottomSheet>
    </>
  );
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 24px;

  .AppButton {
    margin-top: 16px;
    width: 100%;
  }
`;

const Image = styled.div`
  background-image: url("/assets/3d-render-hands-with-pink-heart-inside-fingers.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  height: 135px;
  width: 180px;
  margin: auto auto 16px auto;
`;

const Heading = styled.h2`
  font-size: 22px;
  font-weight: 800;
  margin: 0;
  text-align: center;
`;

const Description = styled.p`
  color: var(--tw-slate-500);
  margin: 0;
  text-align: center;
`;
